export type ProductsImportMessages = {
  importProductsTitle: string;
  importProductsPlaceholder: string;
  downloadImportProductsSampleFile: string;
  importProductsButton: string;
  unsupportedFileFormat: string;
  importProductsSuccess: string;
  importProductsError: string;
};

export const PRODUCTS_IMPORT_MESSAGES: ProductsImportMessages = {
  importProductsTitle: "Planilha de Produtos",
  importProductsPlaceholder: "Importar Produtos",
  downloadImportProductsSampleFile: "Baixar Planilha Modelo",
  importProductsButton: "Importar Produtos",
  unsupportedFileFormat:
    "Formato de arquivo não suportado. Por favor, envie um arquivo xls ou xlsx.",
  importProductsSuccess:
    "Recebemos seu arquivo de produtos! Você será notificado assim que a importação for concluída.",
  importProductsError: "Erro ao importar produtos.",
};
